import * as types from './actionTypes.unloadPage';
import { IUnloadWarningForBillingParams, IUnloadWarningForProjectParams } from './saga.unloadPage';

export const updateUnloadPageListenerForProject = ({ hasListener }: IUnloadWarningForProjectParams) => ({
    type: types.UPDATE_BEFORE_UNLOAD_LISTENER_BECAUSE_OF_LEAVING_PROJECT_REQ,
    hasListener
});

export const updateUnloadPageListenerForBilling = ({ hasListener }: IUnloadWarningForBillingParams) => ({
    type: types.UPDATE_BEFORE_UNLOAD_LISTENER_BECAUSE_OF_LEAVING_FROM_BILLING_REQ,
    hasListener
});